<template>
    <div>
        <!-- User -->
        <template v-if="isUserSignedIn">
            <!-- Received credit -->
            <template v-if="giftRewardAmountCents > 0">
                <transition name="fade">
                    <div class="cash-img-wrapper">
                        <img v-show="imgLoaded" :src="require('home/buy-now/crema-cash-1.png')" class="cash-img" alt="Crema Cash" v-on:load="imgLoaded = true">
                    </div>
                </transition>
                <div class="after-purchase-content">
                    <h3>You earned {{ formatPrice(giftRewardAmountCents, true)}} in Crema Cash</h3>
                    <p class="margin-top-sm">Every time you gift a friend over $30 we will reward you with $1 in site credit to use as you please.</p>
                    <button class="btn-green-lg link-btn" @click="reload()">
                        Give Another Gift
                    </button>
                    <button class="btn-green-transparent-lg link-btn" @click="navigateToCoffeeIndex">
                        Browse Coffees
                    </button>
                </div>
            </template>

            <!-- Didn't receive credit -->
            <template v-else>
                <transition name="fade">
                    <div class="pug-img-wrapper">
                        <img v-show="imgLoaded" :src="require('home/buy-now/pug.png')" class="pug-img" alt="Pug" v-on:load="imgLoaded = true">
                    </div>
                </transition>
                <div class="after-purchase-content">
                    <h3>Congratulations!</h3>
                    <p>Your friend will receive an email explaining how to use your gift any minute now!</p>
                    <button class="btn-green-lg link-btn" @click="reload()">
                        Give Another Gift
                    </button>
                </div>
            </template>
        </template>

        <!-- Non User -->
        <template v-else>
            <transition name="fade">
                <div class="cash-img-wrapper">
                    <img v-show="imgLoaded" :src="require('home/buy-now/crema-cash-5.png')" class="cash-img" alt="Crema Cash" v-on:load="imgLoaded = true">
                </div>
            </transition>
            <div class="after-purchase-content">
                <h3>Take our coffee quiz and get 1/2 off your first order!</h3>
                <button class="btn-green-transparent-lg link-btn margin-top-md" @click="navigateToOnboarding()">
                    Meet Your Match
                </button>
                <button class="btn-green-lg link-btn" @click="reload()">
                    Give Another Gift
                </button>
            </div>
        </template>
    </div>
</template>

<script>
    import CommonMixin from '../../../mixins/common-mixin'

    export default {
        props: {
            giftRewardAmountCents: Number,
            isUserSignedIn: Boolean
        },
        mixins: [
          CommonMixin
        ],
        data: function () {
            return {
                imgLoaded: false
            }
        },
        methods: {
            navigateToCoffeeIndex() {
                window.location.replace('/coffees');
            },
            navigateToOnboarding() {
                window.location.replace('/onboarding');
            },
            reload() {
                location.reload();
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../../../styles/common_home";
    @import "../../../styles/form_home.scss";

    .cash-img-wrapper {
        min-height: 240px;
        text-align: left;
        .cash-img {
            width: 88%;
            height: 88%;
            margin: -12px 0;
        }
    }
    .after-purchase-content {
        padding: 0 2rem .5rem 2rem;
        h3 {
            font-size: 22px;
            line-height: 2rem;
        }
    }
    .pug-img-wrapper {
        width: 200px;
        height: 200px;
        margin: auto;
    }
    .pug-img {
        width: 100%;
        height: 100%;
    }
    .link-btn {
        margin-bottom: 1.5rem;
    }

    @media only screen and (max-width: $max-mobile-width) {
        .after-purchase-content {
            h3 {
                font-size: 20px;
            }
            p {
                font-size: 14px;
            }
        }
    }
</style>
